// @flow
import { LanguagesActionTypes } from './constants';

type LanguagesAction = { type: string, payload: {} | string };

// common success
export const languagesApiResponseSuccess = (actionType: string, data: any): LanguagesAction => ({
    type: LanguagesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const languagesApiResponseError = (actionType: string, error: string): LanguagesAction => ({
    type: LanguagesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getDictionary = (dictionary) => ({
    type: LanguagesActionTypes.GET_DICTIONARY,
    payload: dictionary,
});

export const addDictionary = (dictionary) => ({
    type: LanguagesActionTypes.ADD_DICTIONARY,
    payload: dictionary
})
// export const updateDictionary = (dictionary) => ({
//     type: LanguagesActionTypes.UPDATE_DICTIONARY,
//     payload: dictionary
// })

export const resetLanguages = () => ({
    type: LanguagesActionTypes.RESET,
    payload: {},
});

